module.exports = __webpack_public_path__ + "static/media/icon_project_calendar.36b89149.svg";